// TODO: I18n
const CatalogErrors = {
  GET: {
    default: 'global.catalog.errors.default',
  },
}

export default CatalogErrors
